import { render, staticRenderFns } from "./bounce.vue?vue&type=template&id=4af5fa6c&scoped=true&"
var script = {}
import style0 from "./bounce.vue?vue&type=style&index=0&id=4af5fa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5fa6c",
  null
  
)

export default component.exports